import { ParentTypes } from '@risksmart-app/domain/src/types/consts/parent-type';
import { toTitleCase } from 'src/utils';

// Override entity plural labels with canonical module names for the
// permissions table in the Add/Edit Role modal. Other surfaces continue to
// use the taxonomy translations directly.
type OverriddenParentType =
  | typeof ParentTypes.Document
  | typeof ParentTypes.Obligation
  | typeof ParentTypes.ThirdParty
  | typeof ParentTypes.CustomDatasource
  | typeof ParentTypes.ScimConfiguration;

const permissionLabelOverrides: Record<OverriddenParentType, string> = {
  [ParentTypes.Document]: 'Policy',
  [ParentTypes.Obligation]: 'Compliance',
  [ParentTypes.ThirdParty]: 'Third Party',
  [ParentTypes.CustomDatasource]: 'Custom Data Sources',
  [ParentTypes.ScimConfiguration]: 'SCIM Configurations',
};

const isOverriddenParentType = (key: string): key is OverriddenParentType =>
  key === ParentTypes.Document ||
  key === ParentTypes.Obligation ||
  key === ParentTypes.ThirdParty ||
  key === ParentTypes.CustomDatasource ||
  key === ParentTypes.ScimConfiguration;

// `groupKey` is typed as `string` so callers passing the existing GraphQL
// `Parent_Type_Enum` continue to work without a cast — the runtime values
// match (both enums encode the same `node_type` keys). The type guard
// narrows to the override-map's key set before lookup.
export const getPermissionLabel = (
  groupKey: string,
  fallbackPlural: string
): string =>
  isOverriddenParentType(groupKey)
    ? permissionLabelOverrides[groupKey]
    : toTitleCase(fallbackPlural);
